/* angular:styles/component:css;ccb5208814eb4b324b031c9a6c983e8cc20b20cd24ce0bf575da0647c30510a6;/home/vsts/work/1/s/src/app/components/core/unauthorized/unauthorized.component.ts */
.unauthorized-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  text-align: center;
  color: #555;
}
.warning-icon {
  font-size: 48px;
  color: #faad14;
  margin-bottom: 16px;
}
h2 {
  margin-bottom: 8px;
  color: #333;
}
p {
  margin-bottom: 24px;
  max-width: 420px;
}
/*# sourceMappingURL=unauthorized.component-ZCZINC3T.css.map */
